require('./flashes');

const CHECK_INTERVAL = 3000;

// Based in part upon https://github.com/HubSpot/offline
class OnlineChecker {
  constructor() {
    this.online = true;
    this._wasOnline = true;
    this._setupEvents();
  }

  _setupEvents() {
    $(window).on('online:set', (e, online) => {
      this._setOnline(online);
    });
  }

  _setOnline(online) {
    this.online = online;
    if (this.online !== this._wasOnline) {
      if (this.online) {
        this._goOnline();
      } else {
        this._goOffline();
      }
      this._wasOnline = this.online;
    }
  }

  _goOnline() {
    this._clearFlash();
    this._flash = Flash.show('You are back online. Saving your comments.');
    this._triggerEvent('online:online');
    this._stopChecking();
  }

  _goOffline() {
    this._clearFlash();
    this._flash = Flash.show(
      'You are working offline. Your comments will be saved when you re-connect.',
      { type: 'info', timeout: false }
    );
    this._triggerEvent('online:offline');
    this._startChecking();
  }

  _clearFlash() {
    if (this._flash) {
      Flash.dismiss(this._flash);
      delete this._flash;
    }
  }

  _startChecking() {
    this._stopChecking();
    this.poll = setInterval(() => {
      this._testConnection();
    }, CHECK_INTERVAL);
  }

  _stopChecking() {
    clearInterval(this.poll);
  }

  _testConnection() {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', '/online', true);

    this._checkXHR(
      xhr,
      () => this._onUp(),
      () => this._onDown()
    );

    try {
      xhr.send();
    } catch (e) {
      this._onDown();
    }
  }

  _checkXHR(xhr, onUp, onDown) {
    const checkStatus = () => {
      if (xhr.status && xhr.status < 12000) {
        onUp();
      } else {
        onDown();
      }
    };

    // XMLHttpRequest 2?
    // Note: xhr.onprogress === undefined in browsers without XMLHttpRequest 2
    if (xhr.onprogress === null) {
      // IE8 XDomainRequest has onprogress doesn't implement addEventListener
      const _onerror = xhr.onerror;
      xhr.onerror = () => {
        onDown();
        if (_onerror) _onerror(...arguments);
      };

      const _ontimeout = xhr.ontimeout;
      xhr.ontimeout = () => {
        onDown();
        if (_ontimeout) _ontimeout(...arguments);
      };

      const _onload = xhr.onload;
      xhr.onload = () => {
        checkStatus();
        if (_onload) _onload(...arguments);
      };
      // XMLHttpRequest 1
    } else {
      const _onreadystatechange = xhr.onreadystatechange;
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          checkStatus();
        } else if (xhr.readyState === 0) {
          onDown();
        }

        if (_onreadystatechange) _onreadystatechange(...arguments);
      };
    }
  }

  _onDown() {
    this.online = false;
    if (this.online !== this._wasOnline) {
      this._goOffline();
      this._wasOnline = this.online;
    }
  }

  _onUp() {
    this.online = true;
    if (this.online !== this._wasOnline) {
      this._goOnline();
      this._wasOnline = this.online;
    }
  }

  _triggerEvent(type) {
    $(window).trigger(type);
  }
}

window.ONLINE = new OnlineChecker();
